var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.444 9.85921C20.3581 9.69996 20.1868 9.59999 20 9.60001H12.624L14.488 1.54177C14.5403 1.31879 14.4216 1.09132 14.2043 0.998056C13.9869 0.904794 13.7312 0.971611 13.593 1.15777L3.59301 14.5978C3.48217 14.7441 3.4665 14.9379 3.55249 15.099C3.63848 15.26 3.81151 15.3609 4.00001 15.36H11.376L9.51201 23.4144C9.45969 23.6374 9.57841 23.8649 9.79577 23.9581C10.0131 24.0514 10.2689 23.9846 10.407 23.7984L20.407 10.3584C20.5159 10.2118 20.5302 10.0191 20.444 9.85921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.9fdb8984eaa821023496a81554000b22.svg";
export { ForwardRef as ReactComponent };